export default "__VITE_ASSET__C3ogO0OJ__"